import type { Format } from '../schemas/format';
import { LD_CHSSA } from './ld';
import { PARLI_CHSSA } from './parli';
import { PF_CHSSA, PF_NSDA } from './pf';
import { POLICY_CHSSA } from './policy';

export { LD_CHSSA, PARLI_CHSSA, PF_CHSSA, PF_NSDA, POLICY_CHSSA };

/** Every format the app ships with: event × rules. Times are from each league's published rules; verify locally. */
export const BUILT_IN_FORMATS: Format[] = [PF_CHSSA, LD_CHSSA, POLICY_CHSSA, PARLI_CHSSA, PF_NSDA];

/** The judge's league is CHSSA, so new tournaments start there. */
export const DEFAULT_FORMAT = PF_CHSSA;

export const formatById = (id: string | null | undefined): Format | undefined => BUILT_IN_FORMATS.find((f) => f.id === id);

export const EVENT_NAMES = { pf: 'Public Forum', ld: 'Lincoln-Douglas', policy: 'Policy', parli: 'Parliamentary' } as const;
